export default "__VITE_ASSET__CHWQb_QU__"